import Vue from "vue";
import RefreshAccountNotFoundModal from "./RefreshAccountNotFoundModal.vue";

export function showRefreshAccountNotFoundModal(onClose) {
    const ModalConstructor = Vue.extend(RefreshAccountNotFoundModal);
    const instance = new ModalConstructor({
        propsData: {
            remove: () => {
                if (instance.$el && instance.$el.parentNode) {
                    document.body.removeChild(instance.$el);
                }
                instance.$destroy();
            },
            onClose,
        },
    });

    instance.$mount();
    document.body.appendChild(instance.$el);
    return instance;
}
